import Vue from 'vue';

Vue.component('accessories-filter-component', {
    props: {
        values: {
            type: Array,
        },
    },

    data() {
        return {
            checkboxValues: [],
            showDropdown: false,
        };
    },

    mounted() {
        this.values.forEach((value) => {
            this.checkboxValues.push({
                id: value.replace(/\s+/g, '-').toLowerCase(),
                isActive: true,
                title: value,
            });
        });
    },

    methods: {
        setShowDropdown() {
            this.showDropdown = !this.showDropdown;
        },

        changeValue(filterTitle) {
            const titleId = filterTitle.replace(/\s+/g, '-').toLowerCase();
            const valuesToUpdate = this.checkboxValues.map((item) => {
                if (item.id === titleId)
                    return {
                        id: titleId,
                        isActive: !item.isActive,
                        title: filterTitle,
                    };
                return item;
            });
            this.checkboxValues = valuesToUpdate;
        },

        isCheckedTitle(filterTitle) {
            const title = filterTitle.replace(/\s+/g, '-').toLowerCase();
            const dropdownValue = this.checkboxValues.find(
                (value) => value.id === title,
            );

            return dropdownValue?.isActive || false;
        },
    },
});
